import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-MultiListSearch',
	icon: 'c-MultiListSearch__icon',
	input: 'c-MultiListSearch__input',
	clear: 'c-MultiListSearch__clear',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		width: '100%',
		height: '28px',
		'align-items': 'center',
		'margin-bottom': DefaultTheme.space(4),
		padding: `0 ${DefaultTheme.space(2)}`,
		'background-color': DefaultTheme.background.lightGrey,
	},
	[CSS.input]: {
		flex: '1',
		outline: 'none',
		'font-family': DefaultTheme.font.family,
		'font-size': DefaultTheme.font.size,
		width: '100%',
		border: `${DefaultTheme.space(1)} solid transparent`,
		'padding-left': DefaultTheme.space(1),
		'margin-left': DefaultTheme.space(4),
		'background-color': 'transparent',
	},
	[`${CSS.input}::placeholder`]: {
		opacity: '0.6',
		transition: 'opacity 0.2s ease',
	},
	[`${CSS.input}:focus::placeholder`]: {
		opacity: '0.8',
	},
	[CSS.icon]: {
		'pointer-events': 'none',
	},
};
